package com.devi3east.bashbuddy.features.detail.data.datasources

import com.devi3east.bashbuddy.features.common.data.api.SB_BASE_URL
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import com.devi3east.bashbuddy.features.common.data.models.RecipeListApiResponse
import com.devi3east.bashbuddy.features.common.data.models.toRecipe
import com.devi3east.bashbuddy.features.common.data.domain.entities.RecipeItem

class RecipeDetailRemoteDataSourceImpl(
    private val httpClient: HttpClient
): RecipeDetailRemoteDataSource {

    override suspend fun getRecipeDetail(id: Long): RecipeItem? {
        val httpResponse = httpClient.get("${SB_BASE_URL}lookup.php?i=$id")
        return httpResponse.body<RecipeListApiResponse>().meals.firstOrNull()?.toRecipe()
    }

}